/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputText } from "../../d-dialog-input-text";
import { DThemeWhiteDialogInput } from "./d-theme-white-dialog-input";

export class DThemeWhiteDialogInputText
	extends DThemeWhiteDialogInput
	implements DThemeDialogInputText {}
